import { isTicketRoute, TicketHebType } from "../../../models/types";
import { TicketRoute, FormType, isFormType, Params } from "../../../models/types";


export function setParams(pathname: string): Params{

    const segments: string[] = pathname.split("/").filter(Boolean);

    console.log("Segments", segments);

    const formType: FormType = getFormType(segments);
    const ticketRoute: TicketRoute = getTicketRoute(segments);
    const ticketHebType = getTicketHebType(ticketRoute); 

    const params: Params = {
        formType,
        ticketRoute,
        ticketHebType
    }

    return params;
}

export function getFormType(segments: string[]): FormType {

    const formType = segments[2];

    if(isFormType(formType)){
        return formType;
    }

    else{
        throw new Error("Form type not found");
    }
}


export function getTicketRoute(segments: string[]): TicketRoute {

    const ticketRoute = segments[0];

    if(isTicketRoute(ticketRoute)){
        return ticketRoute;
    }

    else{
        throw new Error("Account type not found");
    }
}

export function getTicketHebType(accountType: TicketRoute): TicketHebType{

    switch (accountType) {
        case "customers":
            return "לקוח-ספק";
        case "items":
            return "פריט";
        case "works":
            return "עבודה";
        case "cars":
            return "רכב";
        case "incomes":
            return "הכנסה";
        case "outcomes":
            return "הוצאה";
        case "banks":
            return "בנק";
        case "cash-boxes":
            return "קופה";
        case "system":
            return "מערכת";
        default:
            throw new Error("Account heb type not found");
    }
}